<div class="left-nav">
    <app-sidemenu></app-sidemenu>
</div>
<div class="maincontent">
    <router-outlet>
    </router-outlet>
</div>
